import moment from "jalali-moment";

function getGeorgianDate(date) {
    return date?.toDate().format('YYYY-MM-DD HH:mm:ss');
}
function getJalaliDate(gregorianDate){
    return moment(gregorianDate).locale('fa').format('jYYYY/jMM/jDD HH:mm');
}
export {getGeorgianDate,getJalaliDate};